export class Pagination {

    /**
     * Pagination constructor
     * @param param
     */
    constructor(param) {
        this.el = param.el;
        this.perPage = param.perPage;
        this.count = param.count;
        this.index = null;
        this.onIndexChange = param.onIndexChange;
        this.indexesElements = [];

        this.countPage = this.count / this.perPage;
    }

    init() {
        this.build();
        this.setIndex(0);
    }

    build() {
        for (let i = 0; i < this.countPage; i++) {
            const pageNumber = document.createElement('div');
            pageNumber.innerHTML = (i + 1).toString();
            pageNumber.addEventListener('click', () => this.setIndex(i));
            this.indexesElements[i] = pageNumber;
        }
        this.indexesElements.forEach(indexEl => this.el.appendChild(indexEl))
    }

    setIndex(value) {
        if (this.index === value) return;
        if (this.index !== null) this.indexesElements[this.index].classList.remove('current');
        this.index = value;
        this.indexesElements[this.index].classList.add('current');
        this.onIndexChange(value);
    }
}